import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class CourseService {
  url: string = environment.api.endpoint;

  constructor(private http: HttpClient) { }

  create(data: any): any{
    return this.http.post(`${this.url}/course/create`, data);
  }

  createv2(data: any): any{
    return this.http.post(`${this.url}/course/v2/create`, data);

  }

  getAll(): any{
    return this.http.get(`${this.url}/courses/all`);
  }

  getCourseById(id: string): any{
    return this.http.get(`${this.url}/course/${id}`);
  }

  getCoursesByState(filter: any): any{
    return this.http.get(`${this.url}/courses/state`, { params: filter });
  }
}
